import * as moment from 'moment-timezone';

export enum MESSAGE_BOARD_ITEM_TYPE {
  PRINTER_ERROR = 'printer_error',
}

export interface IMessageBoardConfig {
  message: string;
  details: any;
  type: MESSAGE_BOARD_ITEM_TYPE | string;
  buttons?: IMessageBoardButton[];
}

export interface IMessageBoardButton {
  label: string;
  role: string;
  cssClass: string;
}

export class MessageBoardItem {
  private static Active_ID: number = 0;

  private _id: number;
  private _message: string;
  private _time: string;
  private _date: string;
  private _type: MESSAGE_BOARD_ITEM_TYPE | string;
  private _buttons?: IMessageBoardButton[];

  private _details: any;

  public added_time: number;

  constructor(config: IMessageBoardConfig) {
    this._id = ++MessageBoardItem.Active_ID;
    this.updateItem(config);
  }

  updateItem(config: IMessageBoardConfig) {
    this._message = config.message;
    this._details = config.details;
    this._buttons = config.buttons;
    this._type = config.type;
  }

  updateDateTime(time: moment.Moment) {
    if (time) {
      this.added_time = time.valueOf();
      this._date = time.format('MMM D');
      this._time = time.format('h:mm a');
    } else {
      time = moment();
      this.added_time = time.valueOf(); // fallback device time
      this._date = time.format('MMM D');
      this._time = time.format('h:mm a');
    }
  }

  public get Buttons(): IMessageBoardButton[] {
    return this._buttons;
  }

  public get ID(): number {
    return this._id;
  }

  public get Message(): string {
    return this._message;
  }

  public get Time(): string {
    return this._time;
  }

  public get Date(): string {
    return this._date;
  }

  public get Details(): any {
    return this._details;
  }

  public get Type(): MESSAGE_BOARD_ITEM_TYPE | string {
    return this._type;
  }
}
